exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-560470b2","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/player/page/leftpicrighttext.vue
// module id = 80
// module chunks = 0